import React from 'react';

/**
 * Render an icon and dynamic label depending on record openStatus
 * @author Ryan McAvoy
 * @date 2023-11-29
 * @param {object} item - the item to render
 * @param {string} item.openStatus - The status of the item
 * @param {string} item.openDate - The opening date of the item
 * @returns {ReactNode}
 */
const PeerCardDateHeader = ({ openStatus, openDate }) => {
  const OpenState = () => {
    const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'ul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    switch (openStatus) {
      case 'open':
      case 'closed':
        return <span className="card-summary-item__text">{openStatus === 'open' ? 'Open for applications' : 'Closed'}</span>;
      case 'upcoming':
        let _start = new Date(openDate);
        _start = _start.getDay() + ' ' + monthNames[_start.getMonth()] + ' ' + _start.getFullYear();
        return <span className="card-summary-item__text">Applications Open: {_start}</span>;
    }
  };

  return openStatus ? (
    <>
      <li className="card-summary-item">
        <svg className="sprite-icon card-summary-item__icon card-summary-item__icon--calendar">
          <use href="#icon-calendar"></use>
        </svg>
        <OpenState />
      </li>
    </>
  ) : null;
};
export default PeerCardDateHeader;
